// extracted by mini-css-extract-plugin
module.exports = {"block":"HouseList_block__qUl25","title":"HouseList_title__37728","container":"HouseList_container__2MuXr","customCheckboxReg":"HouseList_customCheckboxReg__1qzOx"};